"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarPageLink = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
require("@/components/common/dot/semantics/current-indicator");
require("@/components/common/list-item/list-item");
const list_item_styles_1 = require("@/components/common/list-item/list-item.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
/**
 * 사이드바에서 사이트 안의 한 페이지로 이동하는 링크 행.
 * 명령이 아니라 탐색이므로 menu가 아닌 list로 읽히고, 링크마다 자기 Tab 순서를 갖는다.
 * 지금 보고 있는 페이지인지는 주소로 알 수 있어 aria-current="page"를 스스로 판단하고, 그 행의 끝에 점을 찍는다.
 */
let SidebarPageLink = class SidebarPageLink extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.href = '';
        this.label = '';
        this.emoji = '';
    }
    render() {
        const isCurrent = (0, utils_1.isCurrentPage)(this.href);
        return (0, lit_1.html) `
      <a href=${this.href} aria-current=${(0, if_defined_js_1.ifDefined)(isCurrent ? 'page' : undefined)}>
        <mm-list-item
          avatar-variant="tertiary"
          label=${this.label}
          icon=${(0, if_defined_js_1.ifDefined)(this.icon)}
          emoji=${(0, if_defined_js_1.ifDefined)(this.emoji || undefined)}
        >
          ${this.renderCurrentIndicator(isCurrent)}
          <slot name="trailing" slot="trailing"></slot>
        </mm-list-item>
      </a>
    `;
    }
    renderCurrentIndicator(isCurrent) {
        if (!isCurrent)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-current-indicator slot="trailing"></mm-current-indicator>
    `;
    }
};
SidebarPageLink.styles = [
    shared_styles_1.resetStyles,
    list_item_styles_1.interactiveRowStyles,
    (0, lit_1.css) `
      :host {
        display: block;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SidebarPageLink.prototype, "href", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SidebarPageLink.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SidebarPageLink.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SidebarPageLink.prototype, "emoji", void 0);
SidebarPageLink = __decorate([
    (0, decorators_js_1.customElement)('mm-sidebar-page-link')
], SidebarPageLink);
exports.SidebarPageLink = SidebarPageLink;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2lkZWJhci1wYWdlLWxpbmsuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzaWRlYmFyLXBhZ2UtbGluay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBb0Q7QUFDcEQscURBQTJEO0FBQzNELGdFQUF3RDtBQUl4RCwrREFBNEQ7QUFDNUQsbURBQWdEO0FBQ2hELHFGQUFxRjtBQUNyRiwrREFBeUQ7QUFDekQsbUNBQXVDO0FBRXZDOzs7O0dBSUc7QUFFSSxJQUFNLGVBQWUsR0FBckIsTUFBTSxlQUFnQixTQUFRLGdCQUFVO0lBQXhDOztRQVV1QixTQUFJLEdBQUcsRUFBRSxDQUFBO1FBQ1QsVUFBSyxHQUFHLEVBQUUsQ0FBQTtRQUVWLFVBQUssR0FBRyxFQUFFLENBQUE7SUEyQnhDLENBQUM7SUF6QkMsTUFBTTtRQUNKLE1BQU0sU0FBUyxHQUFHLElBQUEscUJBQWEsRUFBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7UUFFMUMsT0FBTyxJQUFBLFVBQUksRUFBQTtnQkFDQyxJQUFJLENBQUMsSUFBSSxpQkFBaUIsSUFBQSx5QkFBUyxFQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUM7OztrQkFHakUsSUFBSSxDQUFDLEtBQUs7aUJBQ1gsSUFBQSx5QkFBUyxFQUFDLElBQUksQ0FBQyxJQUFJLENBQUM7a0JBQ25CLElBQUEseUJBQVMsRUFBQyxJQUFJLENBQUMsS0FBSyxJQUFJLFNBQVMsQ0FBQzs7WUFFeEMsSUFBSSxDQUFDLHNCQUFzQixDQUFDLFNBQVMsQ0FBQzs7OztLQUk3QyxDQUFBO0lBQ0gsQ0FBQztJQUVPLHNCQUFzQixDQUFDLFNBQWtCO1FBQy9DLElBQUksQ0FBQyxTQUFTO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFOUIsT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUF0Q00sc0JBQU0sR0FBRztJQUNkLDJCQUFXO0lBQ1gsdUNBQW9CO0lBQ3BCLElBQUEsU0FBRyxFQUFBOzs7O0tBSUY7Q0FDRixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs2Q0FBVTtBQUNUO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs4Q0FBVztBQUNWO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs2Q0FBZ0I7QUFDZjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7OENBQVc7QUFiM0IsZUFBZTtJQUQzQixJQUFBLDZCQUFhLEVBQUMsc0JBQXNCLENBQUM7R0FDekIsZUFBZSxDQXdDM0I7QUF4Q1ksMENBQWUifQ==